import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgHugSelectedEmojiSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M27.02 26.76c-3.14.14-6.59-.46-8.94-.99-1.1-.24-1.66.09-1.91 1.18-.07.29-.15 1.26 1.61 1.84.19.06.4.14.63.22 2.27.8 6.48 2.29 12.89.41.42-.12.87.12.99.54.12.42-.12.87-.54.99-6.9 2.03-11.44.42-13.87-.44-.22-.08-.42-.15-.6-.21-2.42-.8-2.95-2.51-2.66-3.72.45-1.95 1.84-2.82 3.82-2.38 3.23.72 6.18 1.05 8.52.95 3.38-.14 7.04-2.3 7.74-2.73.48-.3.95-1.17.52-1.96-.47-.88-1.32-.83-1.94-.64-.13.04-.28.09-.46.16-1.05.37-3 1.05-6.01 1.05-1.85 0-3.38-.53-4.86-1.05-1.36-.48-2.65-.93-4.11-.93-3.18.01-4.84 2.53-4.84 5.01V39.9h22.38V26.63l.01-2.76c-1.02.62-4.79 2.73-8.37 2.89ZM23.28 11.43c-.06.29-.1.6-.1.91 0 .31.04.61.1.91 0 .01.01.02.01.03.43 1.94 2.16 3.4 4.23 3.4 2.39 0 4.34-1.95 4.34-4.34 0-2.39-1.95-4.34-4.34-4.34a4.33 4.33 0 0 0-4.22 3.39c-.01.01-.01.02-.02.04Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M21.63 16.68c.57 0 1.13-.13 1.65-.34a5.842 5.842 0 0 1-1.59-4c0-1.55.61-2.96 1.6-4-.52-.22-1.08-.34-1.66-.34a4.34 4.34 0 0 0 0 8.68Z",
    fill: "currentColor"
  }));
}

export { SvgHugSelectedEmojiSecondary as default };
